import { useEffect } from 'react';
import Header from '@/components/layout/Header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, ExternalLink } from 'lucide-react';

export default function TermsOfServicePage() {
  useEffect(() => {
    // Redirect to the central masonic-tools terms and conditions after 3 seconds
    const timer = setTimeout(() => {
      window.location.href = 'https://masonic-tools.co.uk/terms';
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Header />
      <main className="flex-1 px-4 py-8">
        <div className="container mx-auto max-w-4xl">
          <Card>
            <CardHeader>
              <div className="flex items-center gap-3 mb-4">
                <div className="p-3 bg-blue-100 rounded-lg">
                  <FileText className="w-8 h-8 text-blue-900" />
                </div>
                <CardTitle className="text-3xl">Terms and Conditions</CardTitle>
              </div>
              <p className="text-sm text-muted-foreground">
                Redirecting to Masonic Tools Terms and Conditions...
              </p>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg">
                <p className="text-gray-700">
                  The Dining application is part of the Masonic Tools suite. Our Terms and Conditions are maintained centrally for all applications.
                </p>
              </div>

              <div className="prose prose-sm max-w-none">
                <p className="text-gray-600">
                  You are being redirected to the central Terms and Conditions at Masonic Tools. These terms cover all applications in the suite, including Dining, Secretary, and Treasurer.
                </p>

                <div className="mt-6 p-6 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="font-semibold text-gray-900 mb-3">You will be redirected in 3 seconds...</p>
                  <p className="text-sm text-gray-600 mb-4">If you are not automatically redirected, please click the button below:</p>
                  <a
                    href="https://masonic-tools.co.uk/terms"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-blue-900 text-white font-semibold rounded-lg hover:bg-blue-800 transition-all duration-300 hover:shadow-lg"
                  >
                    View Terms and Conditions
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>

                <div className="mt-6 text-sm text-gray-500">
                  <p>
                    <strong>Note:</strong> The central Terms and Conditions cover:
                  </p>
                  <ul className="mt-2 space-y-1">
                    <li>• User accounts and registration across all applications</li>
                    <li>• Payment terms for events and subscriptions</li>
                    <li>• User responsibilities and conduct guidelines</li>
                    <li>• Intellectual property rights and data ownership</li>
                    <li>• Limitations of liability and dispute resolution</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}
